import {
  ApplicationState,
  HotlistStatus,
  HotlistFilterDegree,
  HotlistDateFilter,
} from '~/lib/applicationEnums'

export default {
  applicationState: {
    [ApplicationState.NewCandidate]: 'Neue Bewerbung',
    [ApplicationState.WillBeContacted]: 'Interview vereinbaren',
    [ApplicationState.MoreInfoNeeded]: 'Mehr Infos benötigt',
    [ApplicationState.InApplicationProcess]: 'Interview',
    [ApplicationState.InApplicationProcessPostInterview]: 'Interview Erfolgreich',
    [ApplicationState.Offer]: 'Angebot',
    [ApplicationState.Hired]: 'Eingestellt',
    [ApplicationState.OfferRejected]: 'Angebot abgelehnt',
    [ApplicationState.OfferRetracted]: 'Angebot zurückgezogen',
    [ApplicationState.RejectedWithReason]: 'Abgelehnt',
  },
  hotlistStatus: {
    [HotlistStatus.New]: 'Neuer Kandidat',
    [HotlistStatus.NotInterested]: 'Nicht interessiert',
    [HotlistStatus.Interested]: 'Anfrage geschickt',
    [HotlistStatus.CandidateDeclined]: 'Anfrage abgelehnt',
    [HotlistStatus.Accepted]: 'Anfrage angenommen',
  },
  hotlistFilterDegree: {
    [HotlistFilterDegree.HasDegree]: 'Has Degree',
    [HotlistFilterDegree.NoDegree]: 'No Degree',
    [HotlistFilterDegree.Empty]: 'Empty',
  },
  hotlistDateFilter: {
    [HotlistDateFilter.AllTime]: 'Alle Kandidaten',
    [HotlistDateFilter.ThisWeek]: 'Diese Woche',
    [HotlistDateFilter.ThisMonth]: 'Diesen Monat',
  },
}
